import { TimingType, } from '@debbie/common/dist/workflows/index.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Trash2 } from '../Icons/index.js';
import { Alert, Checkbox, CopyToClipboard, Input, Panel, Select, } from '../index.js';
import { NodeTypes } from './helpers.js';
import RequirementsInput from './RequirementsInput.js';
import TimingInput from './TimingInput.js';
const EdgeEditor = (props) => {
    const lang = useSelector((s) => s.lang);
    const exclusiveContent = useSelector(selectExclusiveContent);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const { edge } = props;
    const { manual, timing, requirements } = edge.data;
    const [priority, setPriority] = useState('');
    useEffect(() => {
        if (edge) {
            setPriority(`${edge.data.priority || 1}`);
        }
    }, [edge]);
    const isStartingPointEdge = edge.source === NodeTypes.StartingPoint;
    return (React.createElement(EdgeEditorPanel, null,
        props.warnings?.map((warning) => (React.createElement(Alert, { message: lang.workflowPathWarnings[warning], size: "small" }))),
        React.createElement("h3", null, me && exclusiveContent?.includes(me.id) ? (React.createElement(CopyToClipboard, { text: edge.id },
            lang.workflows.manualSelection,
            ' ',
            props.editable && (React.createElement(Trash2, { style: { float: 'right', cursor: 'pointer' }, onClick: props.onDelete })))) : (React.createElement(React.Fragment, null,
            lang.workflows.manualSelection,
            ' ',
            React.createElement(Trash2, { style: { float: 'right', cursor: 'pointer' }, onClick: props.onDelete })))),
        React.createElement(Checkbox, { checked: manual, disabled: !props.editable, onChange: (e) => props.onChange(edge.id, {
                manual: e.target.checked,
            }), placeholder: lang.workflows.manualSelection }),
        React.createElement("h3", null, lang.workflows.priority),
        React.createElement("p", null, lang.workflows.priorityDescription),
        React.createElement(Input, { placeholder: lang.workflows.priority, disabled: !props.editable, type: "number", value: priority, onChange: (e) => {
                const val = e.target.value;
                setPriority(val);
                const isNumber = !isNaN(parseInt(val));
                if (isNumber) {
                    props.onChange(edge.id, {
                        priority: parseInt(val),
                    });
                }
            } }),
        !isStartingPointEdge && (React.createElement(React.Fragment, null,
            React.createElement("h3", null, lang.workflows.timing),
            React.createElement(Select, { value: timing.type, disabled: !props.editable, onChange: (e) => {
                    props.onChange(edge.id, {
                        timing: {
                            ...timing,
                            type: e.target.value,
                        },
                    });
                } }, Object.values(TimingType).map((type) => (React.createElement("option", { key: type, value: type }, lang.timingTypes[type])))),
            React.createElement(TimingInput, { disabled: !props.editable ? true : manual, timing: timing, onChange: (timing) => props.onChange(edge.id, {
                    timing,
                }) }),
            React.createElement("br", null))),
        React.createElement("h3", null, lang.workflows.requirements),
        React.createElement(RequirementsInput, { disabled: !props.editable, requirements: requirements, onChange: (requirements) => props.onChange(edge.id, {
                requirements,
            }) }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null)));
};
export default EdgeEditor;
const EdgeEditorPanel = styled(Panel) `
  position: absolute;
  width: 300px;
  z-index: 9;
  left: 40px;
  top: 80px;

  .body {
    max-height: calc(100vh - 160px);
    overflow-y: scroll;
  }
`;
//# sourceMappingURL=EdgeEditor.js.map